import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({

root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5,
    marginRight: theme.spacing.unit,
  },
  iconButton: {
    padding: theme.spacing.unit / 4
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  leftDisplay: {
    marginLeft: theme.spacing.unit * 4,
  },
  textBar: {
    marginLeft: '0px'
  },
  textBarNega: {
    marginTop: "-86px",
    position: "absolute",
    marginLeft: "37px",
    fontSize: "30px",
    color: "#ABABAB",
    backgroudColor: "#FAFAFA"
  },
  textSize: {
    fontSize: '14px'
  },
  textBold: {
    fontWeight: 'bold'
  },
  textEllipsis: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingRight: theme.spacing.unit
  },
  subTitle: {
  },
  linearProgressBox: {
    height: '40px',
    width: '370px',
    border: '1px solid #DDDDDD',
    borderRadius: '30px',
    marginTop: '40px',
    paddingLeft: '6px',
    paddingRight: '6px',
    fontSize: '10px',
  },
  noneBox: {
    height: '35px',
    width: '370px',
    marginTop: '40px',
    paddingLeft: '6px',
    paddingRight: '6px',
    fontSize: '10px',
  },
  linearProgressBar: {
    width: '90%'
  },
  previewButton: {
    background: theme.palette.common.white,
    border: '1px solid #DDDDDD',
    boxShadow: 'inherit',
    padding: '6px 30px',
    borderRadius:'4px',
    fontFamily:'Roboto',
    color:'#666666',
    height:'auto !important',
    fontSize: '16px',
    fontWeight: 'normal',
    '& svg': {
      marginRight: theme.spacing.unit
    }
  },
  viewDetails: {
    fontSize: '14px',
    color: '#666666',
    fontFamily:"Roboto",
    lineHeight:'16px',
    marginTop: '10px',
    textAlign: 'right',
    fontWeight: 'bold',
    paddingRight:'20px',
  },
  previewBtn: {
    float: 'right',
  },
  textValue: {
    margin: '5px 5px 0px',
  },
  icon: {
    margin: '10px 105px 0px',
    height: '20px',
    width: '103px',
    position: 'absolute',
    zIndex:999
  },
  courseCardContainer: {
    zIndex: 100,
    '&:hover': {
      cursor: "pointer"
    },
    width: "100%"
  },
  colorPrimary: {
    backgroundColor: '#D8D8D8',
    width:"100%"
  },
  barColorPrimary: {
    backgroundColor: '#6BCB3E',
   
  },
  parentDiv:{
    position: 'relative',
    width: '90%',
  },
  circle:{
      content:"''",
      height: '12px',
      width:'12px',
      backgroundColor: '#FFF',
      borderRadius: '50%',
      position:'absolute',
      border: '1px solid #bbb',
      top: '-4px',
  },
  textCaption:{
    fontFamily: `'Roboto', 'sans-serif'`,
fontStyle: "normal",
fontWeight: 300,
fontSize: "10px",
lineHeight: "16px"
  }
});